module.exports = __webpack_public_path__ + "static/media/blog1-image.b79b695b.jpg";